import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import loadingGif from "../../assets/img/loading.gif";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import { isApiResponse, isReportAccess, date_range_config, aplloClient, user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import { withRouter } from 'react-router-dom';

// sessionStorage key used to remember the applied filters when the user drills down
// into MobileCaptureDetailReport, so hitting "Back to Summary" restores them exactly.
const FILTERS_STORAGE_KEY = 'mobileCaptureSummaryFilters';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var date_config = date_range_config('0', '0', '2020-02-01','0');
var MobileCaptureSummaryTable='';

// Note: POS vs SOK bucketing logic (confirmed by Westlife/McDonald's - Parvez Khan, 05-Aug-2026):
// pos_number 01-24  => POS counter
// pos_number 25+    => SOK (Self-Order Kiosk)
// Bucketing itself happens server-side (Flask), this component only renders the summary.

class MobileCaptureSummaryReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isChange: false,
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false,
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        //isReportAccess(AllAccessPermissions, "mobile_capture_summary_report");
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });

        // If we're arriving here via "Back to Summary" from the detail report,
        // restore whatever filters were applied before the drill-down. Consumed once.
        // Merchant/Chain/Store/Utid filter widgets are shared components that keep their
        // own internal selection state - they're re-synced separately in componentDidMount
        // via ref.setState() once this.state itself has the restored values (below).
        var savedFiltersRaw = sessionStorage.getItem(FILTERS_STORAGE_KEY);
        if (savedFiltersRaw) {
            try {
                var savedFilters = JSON.parse(savedFiltersRaw);
                this.setState(savedFilters);
                this.restoredFromBack = true;
            } catch (e) {
                console.log('Failed to restore saved filters', e);
            }
            sessionStorage.removeItem(FILTERS_STORAGE_KEY);
        }
    }

    componentDidUpdate() {
     }
    componentDidMount() {
        if (this.restoredFromBack) {
            // Re-sync the filter widgets themselves (Chain/Store/Utid depend on Merchant/Chain
            // selection) before firing the report call, same as reset_all() does.
            if (this.state.object_type === 'Innoviti' || this.state.object_type === 'Merchant') {
                this.refs.reloadChain.getChain(this.state.merchantID || this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            }
            if (this.state.object_type === 'Innoviti' || this.state.object_type === 'Merchant' || this.state.object_type === 'Chain') {
                this.refs.reloadStore.getStore(this.state.chainID || this.state.merchantID || this.state.object_code, 'chain', this.state.object_type, this.state.object_code, false, '');
            }
            this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, false, '');

            // MerchantFilter/ChainFilter/StoreFilter/UtidFilter are shared components -
            // they don't accept an external `value`/`selected` prop, they only track their
            // own selection internally (merchantValue/chainValue/storeID+storeValue/ciutidIds)
            // and report it upward via onSelect callbacks. Since these are common components
            // that must not be touched, we push the restored selection back into each child's
            // own state via its ref - this is exactly the same "selected" shape each of them
            // already keeps internally, so their own render logic picks it up unchanged.
            if (this.refs.merchantFilter) {
                this.refs.merchantFilter.setState({ merchantValue: this.state.merchantValue || [] });
            }
            if (this.refs.reloadChain) {
                this.refs.reloadChain.setState({ chainValue: this.state.chainValue || [] });
            }
            if (this.refs.reloadStore) {
                this.refs.reloadStore.setState({ storeID: this.state.storeID || [] });
            }
            if (this.refs.reloadUtid) {
                this.refs.reloadUtid.setState({ ciutidIds: this.state.ciutidIds || [] });
            }
        }
        this.get_mobile_capture_summary_report(this.state.object_type,this.state.object_code,'');
    }

    // Drill down from a POS/SOK number cell -> txn-level detail report,
    // scoped to store + date range + bucket (POS/SOK) + captured filter (all/captured).
    // Also carries over whatever Merchant/Chain/Utid filters were applied on the summary,
    // and persists them to sessionStorage so "Back to Summary" can restore them.
    handleDrillDown(store_code, store_name, bucket, captured_filter) {
        var filtersToPersist = {
            merchantID: this.state.merchantID,
            chainID: this.state.chainID,
            storeID: this.state.storeID,
            merchantValue: this.state.merchantValue,
            chainValue: this.state.chainValue,
            storeValue: this.state.storeValue,
            ciutidIds: this.state.ciutidIds,
            ciutidValue: this.state.ciutidValue,
            datefrom: this.state.datefrom,
            dateTo: this.state.dateTo,
            datefromShow: this.state.datefromShow,
            dateToShow: this.state.dateToShow,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
        };
        sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(filtersToPersist));

        this.props.history.push('/admin/mobile-capture-detail-report', {
            store_code: store_code,
            store_name: store_name,
            bucket: bucket,
            captured_filter: captured_filter,
            merchantID: this.state.merchantID,
            chainID: this.state.chainID,
            ciutidIds: this.state.ciutidIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            datefromShow: this.state.datefromShow,
            dateToShow: this.state.dateToShow,
            object_type: this.state.object_type,
            object_code: this.state.object_code,
        });
    }

    get_mobile_capture_summary_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            active_mids: merchants,
            active_cids: chains,
            active_sids: stores,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_utid: this.state.ciutidIds,
        })
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            report_code:"mobile_capture_summary_report"
        };
        if ($.fn.DataTable.isDataTable('#MobileCaptureSummaryTable')) {
            $('#MobileCaptureSummaryTable').DataTable().clear().destroy();
        }
        var MobileCaptureSummaryTable = $('#MobileCaptureSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/mobile-capture-summary-report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                // Column keys now match the backend field names exactly (also used as the
                // CSV/download header names) - keep both sides in sync if renamed again.
                columns: [
                    {"data": "store_name"},
                    {"data": "city_name"},
                    {"data": "pos_total_txns"},
                    {"data": "pos_mobile_no_captured"},
                    {"data": "pos_mobile_no_captured_pct"},
                    {"data": "sok_total_txns"},
                    {"data": "sok_mobile_no_captured"},
                    {"data": "sok_mobile_no_captured_pct"},
                    {"data": "overall_capture_pct"},
//                     {"data": "capture_status"},
                ],
                "columnDefs": [
                    {
                        // POS Total Txns -> drill down: all POS-bucket txns for this store
                        render: function (data, type, row) {
                            return "<a href='#' class='mobile-capture-drilldown' data-store-code='" + row['store_code'] + "' data-store-name='" + row['store_name'] + "' data-bucket='POS' data-captured-filter='all'>" + data + "</a>";
                        },
                        "targets": 2
                    },
                    {
                        // POS mobile no captured -> drill down: POS-bucket txns with mobile captured
                        render: function (data, type, row) {
                            return "<a href='#' class='mobile-capture-drilldown' data-store-code='" + row['store_code'] + "' data-store-name='" + row['store_name'] + "' data-bucket='POS' data-captured-filter='captured'>" + data + "</a>";
                        },
                        "targets": 3
                    },
                    {
                        // SOK Total Txns -> drill down: all SOK-bucket txns for this store
                        render: function (data, type, row) {
                            return "<a href='#' class='mobile-capture-drilldown' data-store-code='" + row['store_code'] + "' data-store-name='" + row['store_name'] + "' data-bucket='SOK' data-captured-filter='all'>" + data + "</a>";
                        },
                        "targets": 5
                    },
                    {
                        // SOK mobile no captured -> drill down: SOK-bucket txns with mobile captured
                        render: function (data, type, row) {
                            return "<a href='#' class='mobile-capture-drilldown' data-store-code='" + row['store_code'] + "' data-store-name='" + row['store_name'] + "' data-bucket='SOK' data-captured-filter='captured'>" + data + "</a>";
                        },
                        "targets": 6
                    },
                    {
                        // Color-code POS / SOK / Overall mobile-no-captured % - green >=95%,
                        // yellow 75-94.9%, red <75%. sok_mobile_no_captured_pct can be '-'
                        // (no SOK txns for that store) - keep neutral, no color.
                        render: function (data) {
                            if (data === '-') {
                                return data;
                            }
                            var val = parseFloat(data);
                            var color = val >= 95 ? '#1e8c46' : (val >= 75 ? '#c98a1e' : '#c82828');
                            return "<span style='color:" + color + "; font-weight:600;'>" + data + '%' + "</span>";
                        },
                        "targets": [4, 7, 8]
                    },
//                     {
//                         // Same 3-tier thresholds as above, driven off the numeric overall_capture_pct
//                         render: function (data, type, row) {
//                             var val = parseFloat(row['overall_capture_pct']);
//                             var color = val >= 95 ? '#1e8c46' : (val >= 75 ? '#c98a1e' : '#c82828');
//                             return "<span style='color:" + color + "; font-weight:600;'>" + data + "</span>";
//                         },
//                         "targets": 9
//                     },
                ],

            });
        $('#MobileCaptureSummaryTable').on('click', 'td a.mobile-capture-drilldown', function (e) {
            e.preventDefault();
            var store_code = $(this).data("store-code");
            var store_name = $(this).data("store-name");
            var bucket = $(this).data("bucket");
            var captured_filter = $(this).data("captured-filter");
            that.handleDrillDown(store_code, store_name, bucket, captured_filter);
        })

    }

    MobileCaptureDownloadCheck(e){
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            end_date: this.state.todSend,
            start_date: this.state.yestSend,
            utids: this.state.ciutidIds,
            download: 1,
            report_code:"mobile_capture_summary_report",
            user_id: this.state.user_id,
        }
        this.setState({
            filters:filters
        })
        this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/mobile-capture-summary-report','mobile_capture_summary_report', 30);
    }

    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            ciutidValue: [],
            ciutidIds: '',
            isChange: false,
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            merchantValue: optionSelected,
            isChange: true,
            chainID:'',
            chainValue: null,
            storeID:'',
            storeValue: null,
            ciutidIds: '',
            ciutidValue: null,
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            chainValue: optionSelected,
            isChange: true,
            storeID:'',
            storeValue: null,
            ciutidIds: '',
            ciutidValue: null,
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',
            ciutidValue: null,
        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid, optionSelected) =>
    {
        this.setState({
            ciutidIds:utid,
            ciutidValue: optionSelected !== undefined ? optionSelected : this.state.ciutidValue,
            isChange: true
        });
    }
    render() {
        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Mobile Number Capture Progress (POS vs SOK)</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                        </div>
                                        {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                    </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_mobile_capture_summary_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.MobileCaptureDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="MobileCaptureSummaryTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Store</th>
                                                    <th>City</th>
                                                    <th>POS Total Txns</th>
                                                    <th>POS mobile no captured</th>
                                                    <th>POS mobile no captured%</th>
                                                    <th>SOK Total Txns</th>
                                                    <th>SOK mobile no captured</th>
                                                    <th>SOK mobile no captured%</th>
                                                    <th>Overall Capture %</th>
{/*                                                     <th>Status (Target 95%)</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default withRouter(connect(null,mapDispatchToProps)( MobileCaptureSummaryReport ));